import { render, staticRenderFns } from "./Challenge.vue?vue&type=template&id=2b0846ae&scoped=true"
import script from "./Challenge.vue?vue&type=script&lang=js"
export * from "./Challenge.vue?vue&type=script&lang=js"
import style0 from "./Challenge.vue?vue&type=style&index=0&id=2b0846ae&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b0846ae",
  null
  
)

export default component.exports